<template>
	<div class="dropdown-menu show" :style="style" v-if="controller.menuShow.value">
		<DropdownMenu :items="controller.menuItems.value"></DropdownMenu>
	</div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue';
import DropdownMenu from '@/components/DropdownMenu.vue';

export default {
	components: {
		DropdownMenu
	},

	props: {
		style: {
			type: String,
			default: 'top: 22px; left: 4px; width: 500px'
		},
		controller: {
			type: Object,
			default: () => ({})
		}
	},

	setup(props) {
		const closePopup = () => {
			props.controller.menuShow.value = 0;
		}

		onMounted(() => {
			document.addEventListener("click", closePopup);
		})

		onUnmounted(() => {
			document.removeEventListener("click", closePopup);
		})
	}
}
</script>

<style></style>